import { Component, ElementRef, HostListener, OnInit } from "@angular/core";
import { AbstractControl, UntypedFormBuilder, Validators } from "@angular/forms";
import { CompressImageService } from "src/app/services/compress-image.service";
import { MainService } from "src/app/services/main-service.service";
import { ProposalService } from "src/app/services/proposal/proposal.service";
import { take } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { ToasterService } from "src/app/services/toaster.service";
import { environment } from "src/environments/environment";
// import { format } from "date-fns";

@Component({
  selector: "app-pre-approval",
  templateUrl: "./pre-approval.component.html",
  styleUrls: ["./pre-approval.component.scss"],
})
export class PreApprovalComponent implements OnInit {
  number_regex = /^[0-9]*$/;
  time_value: any = "text";
  collapse: boolean = false;
  current_step: any = 1;
  showbackbutton: boolean = false;
  application_id = null;
  // show: boolean = false;
  token: any;
  hidedl: boolean;
  hidessn: boolean;
  phone_mask: any = [
    "+",
    "1",
    "-",
    /[0-9]/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
  time_mask: any = [/[0-1]/, /\d/, ":", /[0-5]/, /\d/];
  ssn_mask = [
    /[\d*]/,
    /[\d*]/,
    /[\d*]/,
    /[\d*]/,
    /[\d*]/,
    /[\d*]/,
    /[\d*]/,
    /[\d*]/,
    /[\d*]/,
  ];
  email_regex = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  income_regex = new RegExp(
    /^\$?([1-9]{1}[0-9]{0,2}(\,[0-9]{3}){0,2}(\.[0-9]{0,2})?|[1-9]{1}[0-9]{0,6}(\.[0-9]{0,2})?|0(\.[0-9]{0,2})?|(\.[0-9]{1,2})?)$/
  );
  invalid_input_class = {};
  is_same_addres = false;
  zip_obj = {};
  ampm = ["AM", "PM"];
  show_ampm = false;
  am_pm_value = "AM";
  is_skip = false;
  business_info: any;
  approval_data: any;
  is_iframe: boolean;
  doc_local_url: string | ArrayBuffer;
  maxDate = new Date();
  minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 120));
  mask;
  bsConfig = {
    showWeekNumbers: false,
    containerClass: "theme-sky-blue",
    dateInputFormat: "MM-DD-YYYY",
    selectFromOtherMonth: true,
  };
  application_id_from_route: boolean;
  showGoogleApi = false;
  public specialCharacter = this.mainService.specialCharacter;
  public placeFormat = this.mainService.placeFormat;
  public dateOfBirthMask = this.mainService.dateOfBirthMask;
  regexMode: any;
  dateError: boolean = false;
  dateErrors: boolean = false;
  phone_length: any;
  min_phone_length: any;
  environment = environment;
  country_states: any;
  showDropDown: boolean;
  editAddressManually = false;
  editEmployerAddressManually = false;
  editOfficeAddressManually = false;
  customZip = false;
  customEmployerZip = false;
  customOfficeZip = false;
  get employement_type() {
    return this.preapproval_application_form
      .get("third_employement_page")
      .get("employement_type");
  }

  constructor(
    private fb: UntypedFormBuilder,
    public mainService: MainService,
    public proposal: ProposalService,
    private compressImage: CompressImageService,
    private route: ActivatedRoute,
    private _router: Router,
    public toasterService: ToasterService,
  ) {
    this.updateformstatus(
      this.preapproval_application_form,
      this.invalid_input_class,
      false
    );
    let emailToken = localStorage.getItem("x-token")
    if(emailToken){
        emailToken = JSON.parse(emailToken)
        this._router.navigate([], {
          relativeTo:this.route,
          queryParams: { 'x-token':emailToken },
          queryParamsHandling: 'merge',
          replaceUrl:true
        });
    }
  }
  preapproval_application_form = this.fb.group({
    first_page: this.fb.group({
      service: ["", Validators.required],
      first_name: ["", Validators.required],
      last_name: ["", Validators.required],
      customer_gender: [""],
      mobile: [""],
      email: ["", [Validators.pattern(this.email_regex)]],
      time_to_contact: [""],
    }),
    second_page: this.fb.group({
      date_of_birth: ['', Validators.required],
      ssn: ['', [Validators.required]],
      dl_number: ['', [Validators.required]],
      address: ['', Validators.required],
      address_2: [''],
      zip: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      state_code: ['', Validators.required],
      city_id: ['',],
      dl_doc: [''],
    }),
    third_employement_page: this.fb.group({
      employement_type: ["", Validators.required], // 1. employeed //  2. no employement //  3. self employement
      employeed: this.fb.group({
        employer_name: ["", Validators.required],
        employer_mobile: ["", Validators.required],
        employer_address: ["", Validators.required],
        employer_address_2: [""],
        employer_zip: ['', Validators.required],
        employer_city: ['', Validators.required],
        employer_state: ['', Validators.required],
        employer_state_code: ['', Validators.required],
        annual_income: ["", [Validators.required]],
        employer_city_id: [""],
      }),
      unemployeed: this.fb.group({
        payback_methods: ["", Validators.required],
        other_payback_method: [""],
      }),
      self_employeed: this.fb.group({
        profession: ["", Validators.required],
        office_address: ["", Validators.required],
        office_address_2: [""],
        office_zip: ['', Validators.required],
        office_city: ['', Validators.required],
        office_state: ['', Validators.required],
        office_state_code: ['', Validators.required],
        annual_income: ["", [Validators.required]],
        office_city_id: [""],
      }),
    }),
    application_id: [""],
  });
  currentLanguage: any = "en";
  ngOnInit() {
    this.mainService.regex$.subscribe(data => {
      if (data) {
        this.regexMode = data.DL
        console.log(data);
      }
    })
    this.proposal.currentLang.subscribe(value => {
      this.currentLanguage = value
    })
    this.hidedl = false;
    this.hidessn = false;
    this.is_iframe = window.location != window.parent.location ? true : false;
    const token: any = this.route.params;
    this.token = token.value.token;
    this.application_id = token.value.id || null;
    this.application_id_from_route = token.value.id ? true : false;
    // this.is_first_time=
    let parsed_data: any;
    if (this.token) {
      if (this.token.includes("@")) {
        this.token = this.token.split("@").join("");
      }
      if (localStorage.getItem("preapprovalstep")) {
        parsed_data = JSON.parse(localStorage.getItem("preapprovalstep"));
        if (
          parsed_data.token != this.token ||
          (this.application_id &&
            parsed_data.approval_data &&
            parsed_data.approval_data.application_id != this.application_id)
        ) {
          this.cleardata();
        }
      }
      this.get_preapproval_data(this.token);
    } else {
      this.mainService.setLoader(true);
      this._router.navigate(["/invalid"]);
    }
    this.preapproval_application_form
      .get("second_page")
      .get("date_of_birth")
      .setErrors({ invalidSSN: false });

    this.getstate();

    this.preapproval_application_form.valueChanges.subscribe(val => {

      this.updateformstatus(this.preapproval_application_form, this.invalid_input_class, false)
      if (val.first_page.mobile == '') {
        this.preapproval_application_form.get('first_page').get('mobile').markAsPristine()
      }
      if (val.first_page.email == "") {
        this.preapproval_application_form
          .get("first_page")
          .get("email")
          .markAsPristine();
      }
      // if (val && val.second_page && val.second_page.ssn) {
      //   this.validate_ssn()
      // }
    });
    // default employed details show
    this.select_emp_type(1);
    setTimeout(() => {
      this.showGoogleApi = true;
    }, 1000);
  }

  country_info: any;
  currency_info: any;
  get_preapproval_data(token) {
    let data = {
      lead_gen_link_token: token,
      application_id: this.application_id,
    };
    this.mainService.setLoader(true);
    this.proposal
      .formApi("post", `get_preapproval_link_data`, data)
      .subscribe((data) => {
        this.mainService.setLoader(false);
        if (data && typeof data === "string") {
          data = JSON.parse(data);
        }
        if (data.is_error === 1) {
          if (data.override_text) {
            this.toasterService.message(data.override_text,3);
          } else {
            this.toasterService.message(data.err,3);
          }
          this._router.navigate(["/invalid"]);
        } else if (data.is_error === 0) {
          if (
            data.country_info &&
            data.country_info.country &&
            data.country_info.country.country_code
          ) {
            this.mainService.currency_data.country_code =  data.country_info.country.country_code;
            this.country_info = data.country_info.country;
            this.currency_info = data.country_info.currency[0];
            this.phone_length = data?.country_info?.phone_length || 12;
            this.min_phone_length = data?.country_info?.min_phone_length || 7;
            this.updateMasking(this.country_info.country_phone_format);
            this.mainService.dollarSign$.next(data.country_info);
            this.specialCharacter = this.mainService.specialCharacter;
            this.placeFormat = this.mainService.placeFormat;
            this.dateOfBirthMask = this.mainService.dateOfBirthMask;
            this.mainService.document_label = data.country_info.country.identity_label;
            this.mainService.minDocumentIdLength = (data.country_info.country['identity_document_min_length']);
            this.mainService.maxDocumentIdLength = (data.country_info.country['identity_document_max_length']);
            this.preapproval_application_form.get('second_page').get('ssn').setValidators([Validators.minLength(this.mainService.minDocumentIdLength)])
            this.preapproval_application_form.get('second_page').get('ssn').setValidators([Validators.maxLength(this.mainService.maxDocumentIdLength)])
          }
          if (data && data.validation_rules) {
            this.regexMode = data.validation_rules.DL;
            this.mainService.regex$.next(data.validation_rules);
            console.log(this.regexMode, data.validation_rules);
          }
          if (data && data.business_info && data.business_info[0]) {
            this.business_info = data.business_info[0];
            this.business_info.business_name =
              this.business_info && this.business_info.practice_name
                ? this.business_info.practice_name
                : `${this.business_info && this.business_info.title} ${this.business_info && this.business_info.doctor_first_name
                } ${this.business_info && this.business_info.doctor_last_name
                } `;
            this.business_info.business_email = this.business_info
              .practice_email
              ? this.business_info.practice_email
              : this.business_info.doctor_email;
            this.business_info.business_mobile = this.business_info
              .practice_mobile
              ? this.business_info.practice_mobile
              : this.business_info.doctor_mobile;
          }

          if (
            data &&
            data.application_data &&
            data.application_data.length > 0
          ) {
            this.approval_data = data;
            this.patchformvalues(data.application_data[0]);
            if (this.is_lead_incomplete(data.application_data[0])) {
              this.current_step = 1;
            }
          }
          this.getStates();
        }
      });
  }

  async submit_data(is_skip = 0) {
    console.log(this.preapproval_application_form.get('second_page'), ">>>>");
    console.log(this.dateError, this.dateErrors, 'date errorsssssssssssssssssssssssssssss');

    if ((this.dateError || ((this.preapproval_application_form.get('second_page').get("dl_number").value && this.preapproval_application_form.get('second_page').get("dl_number").value.length != 0) && this.dateErrors)) && !is_skip) {
      return;
    }
    let data = {
      lead_gen_link_token: this.token,
      doctor_id: this.business_info.doctor_id,
      application_id:
        this.current_step != 1 || this.application_id_from_route
          ? this.preapproval_application_form.get("application_id").value
          : "",
      current_step: this.current_step,
    };
    if (is_skip == 0) {
      if (this.current_step == 1) {
        if (!this.preapproval_application_form.get("first_page").valid) {
          this.updateformstatus(
            this.preapproval_application_form,
            this.invalid_input_class,
            true
          );
          return;
        }
        if (
          !this.preapproval_application_form.get("first_page").get("mobile")
            .value &&
          !this.preapproval_application_form.get("first_page").get("email")
            .value
        ) {
          return this.toasterService.message("Please enter either Email or Phone number", 3);
        }
      }
      if (
        this.current_step == 2 &&
        !this.preapproval_application_form.get("second_page").valid
      ) {
        this.updateformstatus(
          this.preapproval_application_form,
          this.invalid_input_class,
          true
        );
        return;
      }
      if (this.current_step == 3) {
        if (
          this.employement_type.value == 1 &&
          !this.preapproval_application_form
            .get("third_employement_page")
            .get("employeed").valid
        ) {
          this.updateformstatus(
            this.preapproval_application_form,
            this.invalid_input_class,
            true
          );
          return;
        }
        if (
          this.employement_type.value == 2 &&
          !this.preapproval_application_form
            .get("third_employement_page")
            .get("unemployeed").valid
        ) {
          this.updateformstatus(
            this.preapproval_application_form,
            this.invalid_input_class,
            true
          );
          return;
        }
        if (
          this.employement_type.value == 3 &&
          !this.preapproval_application_form
            .get("third_employement_page")
            .get("self_employeed").valid
        ) {
          this.updateformstatus(
            this.preapproval_application_form,
            this.invalid_input_class,
            true
          );
          return;
        }
      }
    } else {
      this.is_skip = true;
    }

    if (this.current_step == 1) {
      for (const iterator in this.preapproval_application_form.get("first_page")
        .value) {
        data[iterator] =
          this.preapproval_application_form.get("first_page").value[iterator];
      }
    }
    if (this.current_step == 2) {
      if (!is_skip) {
        if ((this.preapproval_application_form.get('second_page').get("ssn").value && this.preapproval_application_form.get('second_page').get("ssn").value.length) && this.preapproval_application_form.get('second_page').get("ssn").invalid) {
          this.toasterService.message(`Please enter a valid ${this.country_info && this.country_info.original_identity_label}`, 3);
          return
        }
        if (this.preapproval_application_form.get('second_page').get("ssn").value || this.preapproval_application_form.get('second_page').get("ssn").value == 0) {
          if (this.country_info && (this.country_info.original_identity_label == 'SSN/EIN' || this.country_info.original_identity_label == 'SIN') && this.preapproval_application_form.get('second_page').get("ssn").value.length > 0) {
            const ssn = await this.validate_ssn()
            if (!ssn) {
              this.toasterService.message(`Please enter a valid ${this.country_info && this.country_info.original_identity_label}`, 3);
              return
            }
          } else if (!this.mainService.validateCountry(this.preapproval_application_form.get('second_page').get("ssn").value)) {
            this.toasterService.message(`Please enter a valid ${this.country_info && this.country_info.original_identity_label}`, 3);
            return
          }

        }
      }
      let dateOfBirth;
      if (
        this.preapproval_application_form
          .get("second_page")
          .get("date_of_birth").value
      ) {
        dateOfBirth = await this.validateDateOfBirth(
          this.preapproval_application_form.get("second_page")
        );
        if (dateOfBirth && !dateOfBirth.futureDate) {
          dateOfBirth = await this.proposal.formatDateStringPromise(
            this.preapproval_application_form
              .get("second_page")
              .get("date_of_birth").value
          );
        }
        if (dateOfBirth && dateOfBirth.futureDate) {
          this.toasterService.message("Please enter a valid date of birth", 3);
          return;
        }
      }
      if(!is_skip || (this.preapproval_application_form.get('second_page').get('zip')?.value && is_skip)) {
        if(!this.preapproval_application_form.get('second_page').get('zip')?.value) {
          this.toasterService.message("Please enter zip code", 3);
          return;
        }
        let getCityId = this.preapproval_application_form.get('second_page').get('city_id')?.value;
        if (!getCityId) {
          await this.getZipCodeData(getCityId,1);
          getCityId = this.preapproval_application_form.get('second_page').get('city_id')?.value;
        }
      }
      let temp_address_data =
        this.zip_obj &&
        this.zip_obj["user_data"] &&
        this.zip_obj["user_data"]["user_data"];
      if (temp_address_data) {
        temp_address_data["addressObj"].city = this.preapproval_application_form
          .get("second_page")
          .get("city").value;
      }
      for (const iterator in this.preapproval_application_form.get(
        "second_page"
      ).getRawValue()) {
        if (
          this.preapproval_application_form.get("second_page").get(iterator)
            .invalid == false
        ) {
          data[iterator] =
            this.preapproval_application_form.get("second_page").getRawValue()[
            iterator
            ];
        }
      }
    }
    if (this.current_step == 3) {
      if (
        this.preapproval_application_form.get("third_employement_page").value
          .employement_type == 1
      ) {
        const empZipCode = this.preapproval_application_form.get('third_employement_page').get('employeed').get('employer_zip')?.value;
        if (!is_skip || (empZipCode && is_skip)) {
          if (!empZipCode) {
            this.toasterService.message("Please enter employer zip code", 3);
            return;
          }
          let getCityId = this.preapproval_application_form.get('third_employement_page').get('employeed').get('employer_city_id')?.value;
          if (!getCityId) {
            await this.getZipCodeData(getCityId, 2);
            getCityId = this.preapproval_application_form.get('third_employement_page').get('employeed').get('employer_city_id')?.value;
          }
        }
        for (const iterator in this.preapproval_application_form
          .get("third_employement_page")
          .get("employeed").getRawValue()) {
          if (
            this.preapproval_application_form
              .get("third_employement_page")
              .get("employeed")
              .get(iterator).invalid == false
          ) {
            data[iterator] = this.preapproval_application_form
              .get("third_employement_page")
              .get("employeed").getRawValue()[iterator];
          }
        }
      } else if (
        this.preapproval_application_form.get("third_employement_page").value
          .employement_type == 2
      ) {
        data["payback_methods"] =
          this.preapproval_application_form
            .get("third_employement_page")
            .get("unemployeed").value["payback_methods"] == "Other"
            ? this.preapproval_application_form
              .get("third_employement_page")
              .get("unemployeed").value["other_payback_method"]
            : this.preapproval_application_form
              .get("third_employement_page")
              .get("unemployeed").value["payback_methods"];
      } else if (
        this.preapproval_application_form.get("third_employement_page").value
          .employement_type == 3
      ) {
        const ofzZipCode = this.preapproval_application_form.get('third_employement_page').get('self_employeed').get('office_zip')?.value;
        if (!is_skip || (ofzZipCode && is_skip)) {
          if (!ofzZipCode) {
            this.toasterService.message("Please enter office zip code", 3);
            return;
          }
          let getCityId = this.preapproval_application_form.get('third_employement_page').get('self_employeed').get('office_city_id')?.value;
          if (!getCityId) {
            await this.getZipCodeData(getCityId, 3);
            getCityId = this.preapproval_application_form.get('third_employement_page').get('self_employeed').get('office_city_id')?.value;
          }
        }
        for (const iterator in this.preapproval_application_form
          .get("third_employement_page")
          .get("self_employeed").getRawValue()) {
          if (
            this.preapproval_application_form
              .get("third_employement_page")
              .get("self_employeed")
              .get(iterator).invalid == false
          ) {
            data[iterator] = this.preapproval_application_form
              .get("third_employement_page")
              .get("self_employeed").getRawValue()[iterator];
          }
        }
      }
      data["employement_type"] = this.preapproval_application_form.get(
        "third_employement_page"
      ).value.employement_type;
    }
    if (this.current_step == 4 && (this.business_info && this.business_info.skip_employment_status == 1)) {
      data["payback_methods"] = 'SELF';
      data["employement_type"] = 2;
    }
    if (data && data["annual_income"]) {
      data["annual_income"] = data["annual_income"].replace("$", "");
      data["annual_income"] = data["annual_income"].replaceAll(",", "");
    }
    let temp_last_step = this.current_step;
    // || is_skip == 1
    if (this.current_step == 3) {
      this.current_step = 4;
    } else {
      this.mainService.setLoader(true);
    }

    if (data && data["date_of_birth"]) {
      const value = data["date_of_birth"].includes("-")
        ? data["date_of_birth"].split("-")
        : data["date_of_birth"].split("/");
      data["date_of_birth"] = value[2] + "-" + value[0] + "-" + value[1];
    }


    let formData: any = new FormData();
    for (const key in data) {
      const firstPage = this.preapproval_application_form.get("first_page");
      const secondPage = this.preapproval_application_form.get("second_page");
      const thirdPage = this.preapproval_application_form.get("third_employement_page").get("employeed")
      const office = this.preapproval_application_form.get("third_employement_page").get("self_employeed")

      if (key === "mobile" && firstPage.value.mobile) {
        const mobile = firstPage.value.mobile;
        const patient_mobile =
          this.country_info.mobile_code + "-" + mobile.split("-").join("");
        formData.append(key, patient_mobile);
      } else if (key === "address" && secondPage.value.address_2) {
        // secondPage.value.address= secondPage.value.address.includes("||")? secondPage.value.address.split("||")[0]
        // :secondPage.value.address;
        formData.delete(key);
        const address = secondPage.value.address || "";
        const address2 = secondPage.value.address_2;
        formData.append(key, `${address} || ${address2}`);
      }
      else if (key === "employer_address" && thirdPage.value.employer_address_2) {
        // secondPage.value.employer_address= secondPage.value.employer_address.includes(" ||")? secondPage.value.employer_address.split(" || ")[0].trim()
        // :secondPage.value.employer_address;
        formData.delete(key);
        const address = thirdPage.value.employer_address || "";
        const address2 = thirdPage.value.employer_address_2;
        formData.append(key, `${address} || ${address2}`);
      }
      else if (key === "office_address" && office.value.office_address_2) {
        // secondPage.value.employer_address= secondPage.value.employer_address.includes(" ||")? secondPage.value.employer_address.split(" || ")[0].trim()
        // :secondPage.value.employer_address;
        formData.delete(key);
        const address = office.value.office_address || "";
        const address2 = office.value.office_address_2;
        formData.append(key, `${address} || ${address2}`);
      }

      else if (key === "address_2") {
        // Do not append 'address_2'
        continue;
      } else {
        formData.append(key, data[key]);
      }
    }


    this.proposal
      .formApi("post", `add_pre_approval_leads`, formData)
      .subscribe((data) => {
        if (data && typeof data === "string") {
          data = JSON.parse(data);
        }
        if (data.is_error === 1) {
          if (data.flag == 551) {
            return this._router.navigate(["/invalid"]);
          }
          if (data.override_text) {
            this.mainService.customPopups(data.override_text, 1);
          } else {
            this.mainService.customPopups(data.err, 1);
          }
          this.current_step = temp_last_step;
        } else if (data.is_error === 0) {
          let customer_email = data?.approval_data?.application_data[0]?.customer_email
          let emailToken = this.mainService.generateEmailToken(customer_email);
          localStorage.setItem("x-token", JSON.stringify(emailToken))
          this._router.navigate([], {
            relativeTo:this.route,
            queryParams: { 'x-token':emailToken },
            queryParamsHandling: 'merge',
            replaceUrl:true
          });


          this.mainService.currency_data.country_code = this.country_info && this.country_info.country_code;
          this.approval_data = data.approval_data;
          this.preapproval_application_form
            .get("application_id")
            .patchValue(this.approval_data.application_id);
          this.patchformvalues(this.approval_data.application_data[0]);
          this.savestate();
          this.updateformstatus(
            this.preapproval_application_form,
            this.invalid_input_class,
            false,
            true
          );
          // this.toasterService.message('success', ' submitted successfully', '');
          //SKIP EMPLOYMENT INFO PAGE WHEN skip_employment_status IS 1
          if (this.current_step == 2 && (this.business_info && this.business_info.skip_employment_status == 1)) {
            this.current_step = 4;
            this.nextStep(this.current_step);
            this.mainService.setLoader(false);
            return this.submit_data();
          }
          if (this.current_step == 4) {
            setTimeout(() => {
              this.current_step = ++this.current_step;
              this.nextStep(this.current_step);
            }, 3000);
          } else {
            this.current_step = ++this.current_step;
            this.nextStep(this.current_step);
          }
        }
        this.mainService.setLoader(false);
      });
  }

  validateDateOfBirth(customerDetails) {
    return new Promise((resolve, reject) => {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;
      const currentDay = currentDate.getDate();
      let customerDob = customerDetails.get("date_of_birth").value;
      customerDob = moment(customerDob, this.mainService.placeFormat).format(
        "MM" +
        this.mainService.specialCharacter[0] +
        "DD" +
        this.mainService.specialCharacter[0] +
        "YYYY"
      );
      let valueSet: any;
      if (!customerDob || customerDob.trim() === "") {
        resolve({ futureDate: true });
        return;
      }

      if (
        customerDob.includes("-") ||
        customerDob.includes("/") ||
        customerDob.includes(".")
      ) {
        // const dobParts = customerDob.split(/[-/.]/);
        // const change = dobParts[0].padStart(2, '0') + '/' + dobParts[1].padStart(2, '0') + '/' + dobParts[2];
        const change =
          customerDob.slice(0, 2) +
          "/" +
          customerDob.slice(3, 5) +
          "/" +
          customerDob.slice(6, 10);
        valueSet = change;
      } else {
        const dobParts = [
          customerDob.slice(0, 2),
          customerDob.slice(2, 4),
          customerDob.slice(4),
        ];
        const change = dobParts.join("/");
        valueSet = change;
        // customerDetails.controls.customerDob.setValue(change);
      }

      const dobParts = valueSet && valueSet.split("/");
      const month = parseInt(dobParts[0]);
      const day = parseInt(dobParts[1]);
      const year = parseInt(dobParts[2]);
      if (
        isNaN(month) ||
        isNaN(day) ||
        isNaN(year) ||
        month < 1 ||
        month > 12 ||
        day < 1 ||
        day > 31 ||
        year < 1900 ||
        year > currentYear
      ) {
        resolve({ futureDate: true });
        return;
      }

      const dobDate = new Date(year, month - 1, day);

      if (
        dobDate.getDate() !== day ||
        dobDate.getMonth() + 1 !== month ||
        dobDate.getFullYear() !== year
      ) {
        resolve({ futureDate: true });
        return;
      }

      if (dobDate > currentDate) {
        resolve({ futureDate: true });
        return;
      }

      const minDobDate = new Date(
        currentYear - 120,
        currentMonth - 1,
        currentDay
      );
      if (dobDate < minDobDate) {
        resolve({ futureDate: true });
        return;
      }
      this.preapproval_application_form
        .get("second_page")
        .get("date_of_birth")
        .setValue(valueSet);
      resolve({ futureDate: false });
    });
  }

  async futureDateValidator(dateString) {
    return new Promise((resolve) => {
      const selectedDate = new Date(dateString);
      const currentDate = new Date();
      if (selectedDate > currentDate) {
        resolve({ futureDate: true }); // Date is in the future, validation passes
      } else {
        resolve({ futureDate: false }); // Date is not in the future, return an error
      }
    });
  }
  getZipselected(zipObj, type?) {
    try {
      if (zipObj && (!zipObj.zip || (zipObj.zip.length<4))) {
        zipObj.zip = ''
        if (zipObj.edit_address_manually) {
          if (type == '2') {
            zipObj.formatted_address = zipObj?.item?.formatted_address || zipObj?.formatted_address || this.preapproval_application_form.get("third_employement_page").get("employeed").get("employer_address").value.trim();
            zipObj.zip = this.preapproval_application_form.get("third_employement_page").get("employeed").get("employer_zip").value.trim();
            zipObj.city = this.preapproval_application_form.get("third_employement_page").get("employeed").get("employer_city").value.trim();
            zipObj.state_code = this.preapproval_application_form.get("third_employement_page").get("employeed").get("employer_state_code").value.trim();
            zipObj.state_name = this.preapproval_application_form.get("third_employement_page").get("employeed").get("employer_state").value.trim();
          } else if (type == '3') {
            zipObj.formatted_address = zipObj?.item?.formatted_address || zipObj?.formatted_address || this.preapproval_application_form.get("third_employement_page").get("self_employeed").get("office_address").value.trim();
            zipObj.zip = this.preapproval_application_form.get("third_employement_page").get("self_employeed").get("office_zip").value.trim();
            zipObj.city = this.preapproval_application_form.get("third_employement_page").get("self_employeed").get("office_city").value.trim();
            zipObj.state_code = this.preapproval_application_form.get("third_employement_page").get("self_employeed").get("office_state_code").value.trim();
            zipObj.state_name = this.preapproval_application_form.get("third_employement_page").get("self_employeed").get("office_state").value.trim();
          } else {
            zipObj.formatted_address = zipObj?.item?.formatted_address || zipObj?.formatted_address || this.preapproval_application_form.get("second_page").get("address").value;
            zipObj.zip = this.preapproval_application_form.get("second_page").get("zip").value.trim();
            zipObj.city = this.preapproval_application_form.get("second_page").get("city").value.trim();
            zipObj.state_code = this.preapproval_application_form.get("second_page").get("state_code").value.trim();
            zipObj.state_name = this.preapproval_application_form.get("second_page").get("state").value.trim();
          }
        }
      }
      if (type === 1) {
        this.preapproval_application_form
          .get("second_page")
          .get("zip")
          .setValue(zipObj?.zip || '');
        this.preapproval_application_form
          .get("second_page")
          .get("city")
          .setValue(zipObj.city || '');
        this.preapproval_application_form
          .get("second_page")
          .get("state")
          .setValue(zipObj.state_name || '');
        this.preapproval_application_form
          .get("second_page")
          .get("state_code")
          .setValue(zipObj.state_code || '');
        this.preapproval_application_form
          .get("second_page")
          .get("city_id")
          .setValue(zipObj.city_id || "");
        this.preapproval_application_form
          .get("second_page")
          .get("address")
          .setValue(zipObj.formatted_address || zipObj?.item?.name || '');
        if (zipObj) {
          this.mainService.zipCode = zipObj;
          this.zip_obj["user_data"] = { user_data: { addressObj: zipObj } };
        }
      } else if (type === 2) {
        this.preapproval_application_form
          .get("third_employement_page")
          .get("employeed")
          .get("employer_zip")
          .setValue(zipObj.zip || '');
        this.preapproval_application_form
          .get("third_employement_page")
          .get("employeed")
          .get("employer_city")
          .setValue(zipObj.city || '');
        this.preapproval_application_form
          .get("third_employement_page")
          .get("employeed")
          .get("employer_state")
          .setValue(zipObj.state_name || '');
        this.preapproval_application_form
          .get("third_employement_page")
          .get("employeed")
          .get("employer_state_code")
          .setValue(zipObj.state_code || '');
        this.preapproval_application_form
          .get("third_employement_page")
          .get("employeed")
          .get("employer_city_id")
          .setValue(zipObj.city_id || "");
        this.preapproval_application_form
          .get("third_employement_page")
          .get("employeed")
          .get("employer_address")
          .setValue(zipObj.formatted_address || zipObj?.item?.name || '');
        if (zipObj) {
          this.mainService.empzip = zipObj;
          this.zip_obj["employed_data"] = {
            employed_data: { addressObj: zipObj },
          };
        }
      } else if (type === 3) {
        this.preapproval_application_form
          .get("third_employement_page")
          .get("self_employeed")
          .get("office_zip")
          .setValue(zipObj.zip || '');
        this.preapproval_application_form
          .get("third_employement_page")
          .get("self_employeed")
          .get("office_city")
          .setValue(zipObj.city || '');
        this.preapproval_application_form
          .get("third_employement_page")
          .get("self_employeed")
          .get("office_state")
          .setValue(zipObj.state_name || '');
        this.preapproval_application_form
          .get("third_employement_page")
          .get("self_employeed")
          .get("office_state_code")
          .setValue(zipObj.state_code || '');
        this.preapproval_application_form
          .get("third_employement_page")
          .get("self_employeed")
          .get("office_city_id")
          .setValue(zipObj.city_id || "");
        this.preapproval_application_form
          .get("third_employement_page")
          .get("self_employeed")
          .get("office_address")
          .setValue(zipObj.formatted_address || zipObj?.item?.name || '');
        this.is_same_addres = false;
        if (zipObj) {
          this.mainService.ofczip = zipObj;
          this.zip_obj["office_data"] = { office_data: { addressObj: zipObj } };
        }
      }
      this.updateformstatus(
        this.preapproval_application_form,
        this.invalid_input_class,
        false
      );
    } catch (err) {
      console.log(err);
    }
  }

  apply() {
    this.collapse = true;
  }
  select_emp_type(val) {
    this.employement_type.setValue(`${val}`);
    this.updateformstatus(
      this.preapproval_application_form,
      this.invalid_input_class,
      false,
      true
    );
    this.is_same_addres = true;
    this.same_address_toggle();
  }

  nextStep(next?) {
    if (next != 5) this.savesteps();
    if (next) {
      this.current_step = next;
    }
    this.savestate();
  }
  savesteps() {
    let current_steps = {
      current_step: this.current_step - 1,
    };
    if (localStorage.getItem("previoussteps")) {
      this.showbackbutton = true;
      let parsed_array = JSON.parse(localStorage.getItem("previoussteps"));
      parsed_array.push(current_steps);
      localStorage.setItem("previoussteps", JSON.stringify(parsed_array));
    } else {
      this.showbackbutton = true;
      localStorage.setItem("previoussteps", JSON.stringify([current_steps]));
    }
  }
  getstate() {
    const preData: any = localStorage.getItem("preapprovalstep") ? JSON.parse(localStorage.getItem("preapprovalstep")) : "";
    console.log(preData, "preData");

    if (preData) {
      let data = JSON.parse(localStorage.getItem("preapprovalstep"));
      for (const key in data) {
        if (key == "preapproval_application_form") continue;
        this[key] = data[key];
      }
      if (data && data.preapproval_application_form) {
        this.preapproval_application_form.patchValue(
          data.preapproval_application_form
        );
      }
      if (!this.preapproval_application_form.get('second_page').get('zip').value) {
        this.preapproval_application_form.get('second_page').get('zip').setValue(data?.zip_obj?.user_data?.user_data?.addressObj?.zip || '');
      }
      if (!this.preapproval_application_form.get('second_page').get('city').value) {
        this.preapproval_application_form.get('second_page').get('city').setValue(data?.zip_obj?.user_data?.user_data?.addressObj?.city || '');
      }
      if (!this.preapproval_application_form.get('second_page').get('city_id').value) {
        this.preapproval_application_form.get('second_page').get('city_id').setValue(data?.zip_obj?.user_data?.user_data?.addressObj?.city_id || '');
      }
      if (!this.preapproval_application_form.get('second_page').get('state').value) {
        this.preapproval_application_form.get('second_page').get('state').setValue(data?.zip_obj?.user_data?.user_data?.addressObj?.state_name || '');
      }
    }
    if (localStorage.getItem("previoussteps")) {
      let parsed_array = JSON.parse(localStorage.getItem("previoussteps"));
      this.showbackbutton = parsed_array.length == 0 ? false : true;
    }
    this.updateformstatus(
      this.preapproval_application_form,
      this.invalid_input_class,
      false
    );
  }
  stepback() {
    if (localStorage.getItem("previoussteps")) {
      let parsed_array = JSON.parse(localStorage.getItem("previoussteps"));
      let val = parsed_array.pop();
      for (const key in val) {
        this[key] = val[key];
      }
      this.showbackbutton = parsed_array.length == 0 ? false : true;
      localStorage.setItem("previoussteps", JSON.stringify(parsed_array));
    }
    this.savestate();
  }
  savestate() {
    let state = {
      current_step: this.current_step,
      preapproval_application_form: this.preapproval_application_form.value,
      approval_data: this.approval_data,
      business_info: this.business_info,
      doc_local_url: this.doc_local_url,
      token: this.token,
      zip_obj: this.zip_obj,
      collapse: this.collapse,
      am_pm_value: this.am_pm_value,
      is_skip: this.is_skip,
    };
    const secondPage = this.preapproval_application_form.get('second_page');
    // const thirdPage = this.preapproval_application_form.get("third_page");

    if (!secondPage) return;

    if (secondPage.get('address').value.includes("||")) {
      const stateManage = secondPage.get('address').value.split("||").map(part => part.trim());
      if (state.current_step === 2 && stateManage.length === 2) {
        secondPage.get('address').setValue(stateManage[0]);
      }
    }
    if (this.zip_obj?.['user_data']?.user_data?.addressObj) {
      secondPage.get('zip').setValue(this.zip_obj?.['user_data']?.user_data?.addressObj?.zip);
      secondPage.get('city').setValue(this.zip_obj?.['user_data']?.user_data?.addressObj?.city);
      secondPage.get('city_id').setValue(this.zip_obj?.['user_data']?.user_data?.addressObj?.city_id);
      secondPage.get('state').setValue(this.zip_obj?.['user_data']?.user_data?.addressObj?.state_name);
    }
    localStorage.setItem("preapprovalstep", JSON.stringify(state));
  }

  async add_address(data: any, type?: string) {
    if (!data) {
      return;
    }
    this.mainService.setLoader(true);
    try {
      const response = await this.proposal
        .formApi("post", `add_address_line_two`, data)
        .toPromise();
      if (response && response.data) {
        switch (type) {
          case "second_page":
            this.preapproval_application_form
              .get("second_page.city_id")
              .setValue(response.data.city_id);
            break;
          case "employeed":
            this.preapproval_application_form
              .get("third_employement_page")
              .get("employeed.employer_city_id")
              .setValue(response.data.city_id);
            break;
          case "self_employeed":
            this.preapproval_application_form
              .get("third_employement_page")
              .get("self_employeed.office_city_id")
              .setValue(response.data.city_id);
            break;
          default:
            break;
        }
        this.mainService.setLoader(false);
        return true;
      } else {
        throw new Error("An error occurred while adding address.");
      }
    } catch (error) {
      console.error(error);
      this.mainService.setLoader(false);
      throw error;
    }
  }

  fileChangeEvent(event: any) {
    if (
      event &&
      event.target &&
      event.target.files &&
      event.target.files.length > 0
    ) {
      let file = event.target.files;
      if (file[0].size <= 0) {
        this.toasterService.message("Invalid file.",3);
        return false;
      }

      if (
        file[0].type !== "image/png" &&
        file[0].type !== "application/pdf" &&
        file[0].type !== "image/jpeg" &&
        file[0].type !== "image/jpg"
      ) {
        this.toasterService.message(
          "File type not supported. Please upload a valid file(.pdf, .jpeg, .png).",3
        );
        return false;
      }

      if (file[0].size > 10485760) {
        this.toasterService.message(
          "File size must be less than 10MB.",3
        );
        return false;
      }
      var reader = new FileReader();
      reader.readAsDataURL(file[0]);
      reader.onload = (_event) => {
        this.doc_local_url = reader.result;
      };
      if (file[0].type === "application/pdf") {
        if (file[0]) {
          this.preapproval_application_form
            .get("second_page")
            .get("dl_doc")
            .patchValue(file[0]);
        } else {
          this.toasterService.message("Please select valid file",3);
        }
      } else {
        if (
          file[0].type === "image/png" ||
          file[0].type === "image/jpeg" ||
          file[0].type === "image/jpg"
        ) {
          const image: File = file[0];
          this.mainService.setLoader(true);
          this.compressImage
            .compress(image)
            .pipe(take(1))
            .subscribe((compressedImage) => {
              this.mainService.setLoader(false);
              if (file) {
                this.preapproval_application_form
                  .get("second_page")
                  .get("dl_doc")
                  .patchValue(compressedImage);
              } else {
                this.toasterService.message(
                  "Please select valid file",3
                );
              }
            });
        }
      }
    }
  }

  copy(val) {
    if (window.navigator) window.navigator["clipboard"].writeText(val);
    this.toasterService.message(`Application ID:  ${val} copied`,1);
  }

  closeIframe() {
    window.parent && window.parent.postMessage("iframe_closed", "*");
    localStorage.removeItem("preapprovalstep");
    localStorage.removeItem("previoussteps");
  }

  updateformstatus(
    form,
    invalid_class_array,
    skip_edit_input_element_check,
    mark_all_input_valid = false
  ) {
    if (form.hasOwnProperty("controls")) {
      for (const key in form.controls) {
        const element = form.controls[key];
        // console.log(element,"element");

        if (element.hasOwnProperty("controls")) {
          if (!invalid_class_array.hasOwnProperty(key)) {
            invalid_class_array[key] = {};
          }
          this.updateformstatus(
            element,
            invalid_class_array[key],
            skip_edit_input_element_check,
            mark_all_input_valid
          );
        } else {
          if (!invalid_class_array.hasOwnProperty(key)) {
            invalid_class_array[key] = { "has-error": false };
          }
          if (
            (element.dirty == true || skip_edit_input_element_check) &&
            element.valid == false && element.status != 'DISABLED'
          ) {
            invalid_class_array[key]["has-error"] = true;
          } else if (element.valid == true || element.status == 'DISABLED') {
            invalid_class_array[key]["has-error"] = false;
          }
          if (element.value != "") {
            element.markAsDirty();
          }
          if (mark_all_input_valid) {
            invalid_class_array[key]["has-error"] = false;
            // if (key == "annual_income") {
            //   element.markAsPristine()
            // }
          }
        }
      }
    } else return;
  }

  patchformvalues(data) {
    this.preapproval_application_form.patchValue({
      first_page: {
        service: data.service || "",
        first_name: data.customer_first_name || "",
        last_name: data.customer_last_name || "",
        customer_gender: data.customer_gender || "",
        mobile: data.customer_mobile
          ? this.mobile_number(data.customer_mobile)
          : "",
        email: data.customer_email ? data.customer_email : "",
        time_to_contact: data.time_to_contact || "",
      },
      second_page: {
        date_of_birth: data.date_of_birth
          ? this.mainService.getDatePlan(data.date_of_birth)
          : "",
        ssn: data.ssn || "",
        dl_number: data.dl_number || "",
        address: data.customer_address || "",
        zip: data.customer_zip || "",
        city: data.customer_city || "",
        state: data.customer_state || "",
        city_id: data.customer_city_id || "",
        dl_doc: data.dl_doc || "",
      },
      third_employement_page: {
        employement_type: data.employement_type || "",
        employeed: {
          employer_name: data.employer_name || "",
          employer_mobile: data.employer_mobile
            ? this.mobile_number(data.employer_mobile)
            : "",
          employer_address: data.employer_address || "",
          employer_zip: data.employer_zip || "",
          employer_city: data.employer_city || "",
          employer_state: data.employer_state || "",
          annual_income: data.annual_income != 0 ? data.annual_income : "",
          employer_city_id: data.employer_city_id || "",
        },
        unemployeed: {
          payback_methods: data.payback_methods || "",
        },
        self_employeed: {
          profession: data.profession || "",
          office_address: data.office_address || "",
          office_zip: data.office_zip || "",
          office_city: data.office_city || "",
          office_state: data.office_state || "",
          annual_income: data.annual_income != 0 ? data.annual_income : "",
          office_city_id: data.office_city_id || "",
        },
      },
      application_id: data.application_id || "",
    });
    if (data.dl_doc) {
      this.doc_local_url = data.dl_doc;
    }
    this.hidedl = true;
    this.hidessn = true;
  }

  mobile_number(val) {
    if (val && val.substring(0, 3) == "+1-") {
      val = val.split("-");
      val.splice(0, 1);
      val = val.join("").split("");
      val.splice(3, 0, "-");
      val.splice(7, 0, "-");
      val = val.join("");
    } else if (val) {
      val = val.split("-");
      val = val.join("").split("");
      val.splice(3, 0, "-");
      val.splice(7, 0, "-");
      val = val.join("");
    }
    return val;
  }
  view_docs(blobUrl) {
    if (blobUrl.indexOf("http") !== -1) {
      window.open(blobUrl);
    } else {
      const fileWindow = window.open();
      const url = blobUrl;
      fileWindow.document.write(
        "<title></title>" +
        '<body style="overflow:hidden;margin:0;display:grid;place-content:center;background:black;">' +
        '<object width="100vw" width="-webkit-fill-available" height="100vh" style="width:100vw;height:100vh;" height="-webkit-fill-available" type="application/pdf" data="' +
        encodeURI(url) +
        '"></object>' +
        "</body>"
      );
    }
  }
  delete_docs() {
    this.doc_local_url = "";
    this.preapproval_application_form
      .get("second_page")
      .get("dl_doc")
      .patchValue("");
  }

  send_application_receipt() {
    let data = {
      application_id: this.approval_data.application_id,
    };
    this.mainService.setLoader(true);
    this.proposal
      .formApi("post", `email_text_app_comp`, data)
      .subscribe((data) => {
        this.mainService.setLoader(false);
        if (data && typeof data === "string") {
          data = JSON.parse(data);
        }
        if (data.is_error === 1) {
          if (data.override_text) {
            this.toasterService.message("error", data.override_text);
          } else {
            this.toasterService.message("error", data.err);
          }
        } else if (data.is_error === 0) {
          this.toasterService.message("Sent successfully", 1);
        }
      });
  }
  same_address_toggle() {
    this.is_same_addres = !this.is_same_addres;
    if (this.is_same_addres) {
      this.zip_obj["office_data"] = { office_data: { addressObj: this.zip_obj?.['user_data']?.user_data?.addressObj } };
      this.preapproval_application_form
        .get("third_employement_page")
        .get("self_employeed")
        .patchValue(
          {
            office_address: this.preapproval_application_form.get("second_page").get("address").value,
            office_address_2: this.preapproval_application_form.get("second_page").get("address_2").value,
            office_zip: this.preapproval_application_form.get('second_page').get('zip').value || this.zip_obj?.['user_data']?.user_data?.addressObj?.zip,
            office_city: this.preapproval_application_form.get("second_page").get("city").value || this.zip_obj?.['user_data']?.user_data?.addressObj?.city,
            office_city_id: this.preapproval_application_form.get("second_page").get("city_id").value || this.zip_obj?.['user_data']?.user_data?.addressObj?.city_id,
            office_state: this.preapproval_application_form.get("second_page").get("state").value || this.zip_obj?.['user_data']?.user_data?.addressObj?.state_name,
            office_state_code: this.preapproval_application_form.get("second_page").get("state_code").value || this.zip_obj?.['user_data']?.user_data?.addressObj?.state_code
          }
        );
    } else {
      this.preapproval_application_form
        .get("third_employement_page")
        .get("self_employeed")
        .patchValue(
          {
            office_address: "",
            office_address_2: "",
            office_zip: "",
            office_city: "",
            office_city_id: "",
            office_state: "",
            office_state_code: ""
          }
        );
      this.preapproval_application_form.get("third_employement_page").get("self_employeed").markAsPristine();
      this.updateformstatus(
        this.preapproval_application_form,
        this.invalid_input_class,
        false,
        true
      );
    }
  }
  cleardata() {
    localStorage.removeItem("preapprovalstep");
    localStorage.removeItem("previoussteps");
    this._router.navigate([`/pre-approval-application/${this.token}`], {
      relativeTo: this.route.parent,
    });
    setTimeout(() => {
      window.location.reload();
    }, 0);
  }

  async validate_ssn() {
    console.log("commig");

    return new Promise((res, rej) => {
      let ssn: any = (
        this.preapproval_application_form.get("second_page").get("ssn").value +
        ""
      ).match(/\d+/g);

      ssn = ssn && ssn.join("");
      if (!/^\d+$/.test(ssn)) {
        res(false);
      }
      if (ssn == null) {
        console.log(ssn == null, ">>>>>>>>");
        res(false);
      }

      if (ssn && ssn.length != 9) {
        this.handleInvalidSSN();
        res(false);
      }

      const invalidFirstThree = ["000", "666"];
      const invalidMiddleTwo = ["00"];
      const invalidLastFour = ["0000"];
      const invalidSSNs = [
        "078051120",
        "111111111",
        "123456789",
        "219099999",
        "999999999",
      ];
      const invalidRangeStart = "987654320";
      const invalidRangeEnd = "987654329";

      let firstThree = ssn.substring(0, 3);
      let middleTwo = ssn.substring(3, 5);
      let lastFour = ssn.substring(5, 9);

      if (
        invalidFirstThree.includes(firstThree) ||
        invalidMiddleTwo.includes(middleTwo) ||
        invalidLastFour.includes(lastFour) ||
        invalidSSNs.includes(ssn) ||
        (ssn >= invalidRangeStart && ssn <= invalidRangeEnd)
      ) {
        this.handleInvalidSSN();
        res(false);
      }
      res(true);
    });
  }

  handleInvalidSSN() {
    // this.preapproval_application_form.get('second_page').get('ssn').setErrors({ invalidSSN: true });
    this.updateformstatus(
      this.preapproval_application_form,
      this.invalid_input_class,
      false
    );
  }

  validate_annual_income() {
    if (
      this.preapproval_application_form
        .get("third_employement_page")
        .get("employeed")
        .get("annual_income").value
    ) {
      if (
        Number(
          this.preapproval_application_form
            .get("third_employement_page")
            .get("employeed")
            .get("annual_income").value
        ) < 1
      ) {
        this.preapproval_application_form
          .get("third_employement_page")
          .get("employeed")
          .get("annual_income")
          .setErrors({ invalidSSN: true });
        this.updateformstatus(
          this.preapproval_application_form,
          this.invalid_input_class,
          false
        );
      } else {
        this.preapproval_application_form
          .get("third_employement_page")
          .get("employeed")
          .get("annual_income")
          .setErrors(null);
        this.updateformstatus(
          this.preapproval_application_form,
          this.invalid_input_class,
          false
        );
      }
    }
    if (
      this.preapproval_application_form
        .get("third_employement_page")
        .get("self_employeed")
        .get("annual_income").value
    ) {
      if (
        Number(
          this.preapproval_application_form
            .get("third_employement_page")
            .get("self_employeed")
            .get("annual_income").value
        ) < 1
      ) {
        this.preapproval_application_form
          .get("third_employement_page")
          .get("self_employeed")
          .get("annual_income")
          .setErrors({ invalidSSN: true });
        this.updateformstatus(
          this.preapproval_application_form,
          this.invalid_input_class,
          false
        );
      } else {
        this.preapproval_application_form
          .get("third_employement_page")
          .get("self_employeed")
          .get("annual_income")
          .setErrors(null);
        this.updateformstatus(
          this.preapproval_application_form,
          this.invalid_input_class,
          false
        );
      }
    }
  }

  convert_time_into_24_hour_format(time) {
    let temp_time_to_contect = time.split(":");
    if (this.am_pm_value == "PM") {
      if (temp_time_to_contect[0] != 12) {
        temp_time_to_contect[0] = 12 + Number(temp_time_to_contect[0]);
      }
    } else {
      if (temp_time_to_contect[0] == 12) {
        temp_time_to_contect[0] = "00";
      }
    }
    return temp_time_to_contect.join(":");
  }
  convert_time_into_12_hour_format(time) {
    let temp_time_to_contect = time.split(":");
    if (temp_time_to_contect[0] >= 13) {
      temp_time_to_contect[0] = Number(temp_time_to_contect[0]) - 12;
      this.am_pm_value = "PM";
    } else if (temp_time_to_contect[0] == 12) {
      this.am_pm_value = "PM";
    } else if (temp_time_to_contect[0] == 0) {
      temp_time_to_contect[0] = 12;
      this.am_pm_value = "AM";
    } else {
      this.am_pm_value = "AM";
    }
    return temp_time_to_contect.join(":");
  }
  @HostListener("click", ["$event.target"]) onClick(e) {
    if (e.classList.contains("am_pm_text")) {
    } else {
      this.show_ampm = false;
    }
  }

  is_lead_incomplete(data) {
    let is_personal_info_incomplete =
      !data.date_of_birth ||
      !data.ssn ||
      !data.dl_number ||
      !data.customer_address ||
      !data.customer_city ||
      !data.customer_zip ||
      !data.customer_state;
    let is_employeed_info_incomplete =
      !data.employer_name ||
      !data.employer_mobile ||
      !data.employer_address ||
      !data.employer_city ||
      !data.employer_zip ||
      !data.employer_state ||
      !data.annual_income ||
      data.annual_income == "0";
    let is_self_employeed_incomplete =
      !data.profession ||
      !data.office_address ||
      !data.office_city ||
      !data.office_zip ||
      !data.office_state ||
      !data.annual_income ||
      data.annual_income == "0";

    if (
      is_personal_info_incomplete &&
      (!data.employement_type ||
        (data.employement_type == 1 && is_employeed_info_incomplete) ||
        (data.employement_type == 2 && !data.payback_methods) ||
        (data.employement_type == 3 && is_self_employeed_incomplete))
    ) {
      data.incomplete_status = 3;
      return true;
    } else if (is_personal_info_incomplete) {
      data.incomplete_status = 1;
      return true;
    } else if (
      !data.employement_type ||
      (data.employement_type == 1 && is_employeed_info_incomplete) ||
      (data.employement_type == 2 && !data.payback_methods) ||
      (data.employement_type == 3 && is_self_employeed_incomplete)
    ) {
      data.incomplete_status = 2;
      return true;
    }
    return false;
  }
  download_lead_reciept() {
    let params = {
      application_id: this.approval_data.application_id,
      current_lang: this.currentLanguage,
    };
    this.mainService.setLoader(true);
    this.proposal.downloadApi("download_leads_reciept", params, 0).subscribe(
      (data: any) => {
        console.log(data);
        this.mainService.setLoader(false);
      },
      (error: any) => {
        console.log(error);
        this.mainService.setLoader(false);
      }
    );
  }
  ngOnDestroy() {
    localStorage.removeItem("preapprovalstep");
    localStorage.removeItem("previoussteps");
  }

  ssn_val = "";
  ssn_disp = false;
  changeSSNValue(event) {
    // if(!this.ssn_disp){
    //   if(this.hidessn){
    //     this.ssn_disp=true
    //     this.ssn_val = event.target.value;
    //     let arString = String(this.ssn_val).split('').map(item=> '*').join();
    //     event.target.value=arString
    //     event.target.type="text";
    //     setTimeout((val) => {
    //       console.log(val,"valval")
    //       event.target.type="password";
    //       if(val.length<=8){
    //         event.target.value=val+event.key;
    //       }else{
    //         event.target.value=val;
    //         event.target.blur()
    //       }
    //       this.ssn_disp=false
    //     }, 200,this.ssn_val);
    //   }
    // }
  }
  changeDLValue(event) {
    // if(!this.ssn_disp){
    //   if(this.hidessn){
    //     this.ssn_disp=true
    //     this.ssn_val = event.target.value;
    //     let arString = String(this.ssn_val).split('').map(item=> '*').join();
    //     event.target.value=arString
    //     event.target.type="text";
    //     setTimeout((val) => {
    //       console.log(val,"valval")
    //       event.target.type="password";
    //       if(val.length<=19){
    //         event.target.value=val+event.key;
    //       }else{
    //         event.target.value=val;
    //         event.target.blur()
    //       }
    //       this.ssn_disp=false
    //     }, 200,this.ssn_val);
    //   }
    // }
  }

  // check for mobile number
  customerDetailsCheckPhone() {
    const email =
      this.preapproval_application_form.get("first_page.email").value;
    const mobile =
      this.preapproval_application_form.get("first_page.mobile").value;

    if (!email && !mobile) {
      this.mainService.customPopups("Please select Email or Phone number", 1);
      return;
    }

    if (email && !mobile) {
      this.submit_data();
      return;
    }

    const params = {
      patient_mobile: mobile.split("-").join(""),
      contract_patient_token: this.token,
      patient_mobile_country_code: this.country_info.mobile_code,
      is_leads: 1,
    };

    this.mainService.setLoader(true);
    this.proposal
      .formApi("post", `is_valid_mobile_number`, params)
      .subscribe((resp) => {
        this.mainService.setLoader(false);
        if (!resp.is_error) {
          this.submit_data();
        } else {
          this.mainService.customPopups(
            resp.original_text || resp.err,
            resp.is_error
          );
        }
      });
  }

  updateMasking(format: "") {
    format = format ? format : "";
    this.mask = format.replace(/#/g, "0");
  }

  change_pay_back_method() {
    if (
      this.preapproval_application_form
        .get("third_employement_page")
        .get("unemployeed")
        .get("payback_methods").value == "Other"
    ) {
      this.preapproval_application_form
        .get("third_employement_page")
        .get("unemployeed")
        .get("other_payback_method")
        .setValidators([Validators.required]);
    } else {
      this.preapproval_application_form
        .get("third_employement_page")
        .get("unemployeed")
        .get("other_payback_method")
        .setErrors(null);
      this.preapproval_application_form.updateValueAndValidity();
    }
  }
  enterNumberOnly(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  // addZero(event: any): void {
  //   const inputValue = event.target.value;
  //   // Check if the month part needs '0'
  //   if (inputValue.length >= 2 && inputValue.indexOf("/") === 1) {
  //     const month = inputValue.substring(0, 2);
  //     const months = parseInt(month, 10);
  //     if (months > 0 && months <= 9) {
  //       const maskedValue = "0" + months + inputValue.substring(2);
  //       this.preapproval_application_form.get('second_page').get('date_of_birth').setValue(maskedValue)
  //       return;
  //     }
  //   } else if (inputValue.length >= 5 && inputValue.indexOf("/") === 2) {
  //     const day = inputValue.substring(3, 5);
  //     const numericDay = parseInt(day, 10);
  //     if (numericDay > 0 && numericDay <= 9) {
  //       const maskedValue =
  //         inputValue.substring(0, 3) +
  //         "0" +
  //         numericDay +
  //         inputValue.substring(5);
  //       this.preapproval_application_form.get('second_page').get('date_of_birth').setValue(maskedValue)
  //     }
  //   }
  // }

  blurDataUpdate(event) {
    const splitSeries = this.dateOfBirthMask.split(this.specialCharacter[0]);
    const formateSeriesd = splitSeries.findIndex((x) => x === "d0");
    if (event.target.value) {
      const splittedValue = (event.target.value + "").split(
        this.specialCharacter[0]
      );
      if (
        splittedValue &&
        splittedValue[formateSeriesd] &&
        splittedValue[formateSeriesd].length == 1
      ) {
        splittedValue[formateSeriesd] = "0" + splittedValue[formateSeriesd];
        this.preapproval_application_form
          .get("second_page")
          .get("date_of_birth")
          .setValue(splittedValue.join(this.specialCharacter[0]));
      }
    }
  }

  addZero(event: any): void {
    const splitSeries = this.dateOfBirthMask.split(this.specialCharacter[0]);
    const formateSeriesm = splitSeries.findIndex((x) => x === "M0");
    const formateSeriesd = splitSeries.findIndex((x) => x === "d0");
    const formateSeriesy = splitSeries.findIndex((x) => x === "0000");
    const monthIndex = formateSeriesm;
    const dayIndex = formateSeriesd;
    const yearIndex = formateSeriesy;

    if (event.target.value && event.data) {
      const splittedValue = (event.target.value + "").split(
        this.specialCharacter[0]
      );
      if (splittedValue && splittedValue[formateSeriesm]) {
        if (
          splittedValue &&
          splittedValue[formateSeriesm] &&
          splittedValue[formateSeriesm].length == 1 &&
          splittedValue[formateSeriesm] >=
          (monthIndex == 0 ? "1" : monthIndex == 1 ? "2" : "2")
        ) {
          if (
            monthIndex == 0 &&
            splittedValue[formateSeriesm][0] == "1" &&
            !splittedValue[formateSeriesd]
          ) {
            this.preapproval_application_form
              .get("second_page")
              .get("date_of_birth")
              .setValue(splittedValue.join(this.specialCharacter[0]));
          } else {
            splittedValue[formateSeriesm] = "0" + splittedValue[formateSeriesm];
            this.preapproval_application_form
              .get("second_page")
              .get("date_of_birth")
              .setValue(splittedValue.join(this.specialCharacter[0]));
          }
        } else if (
          dayIndex == 2 &&
          monthIndex == 1 &&
          splittedValue &&
          splittedValue[formateSeriesm]
        ) {
          if (
            splittedValue[formateSeriesm][0] != "0" &&
            splittedValue[formateSeriesm][1] >= "3"
          ) {
            splittedValue[formateSeriesm] = splittedValue[formateSeriesm][0];
          } else if (
            splittedValue && splittedValue[formateSeriesm] && (splittedValue[formateSeriesm].length == 1 && splittedValue[formateSeriesm][0] == "1" && (splittedValue[formateSeriesd] &&
              splittedValue[formateSeriesd][0] >= "3"))
          ) {
            splittedValue[formateSeriesm] = "0" + splittedValue[formateSeriesm];
          }
          this.preapproval_application_form
            .get("second_page")
            .get("date_of_birth")
            .setValue(splittedValue.join(this.specialCharacter[0]));
        } else if (
          dayIndex == 0 &&
          monthIndex == 1 &&
          this.specialCharacter[0]
        ) {
          if (this.specialCharacter && this.specialCharacter[0].includes("/")) {
            if (
              splittedValue &&
              splittedValue[formateSeriesm] &&
              splittedValue[formateSeriesy] &&
              splittedValue[formateSeriesm][0] == "1" &&
              splittedValue[formateSeriesy][0] >= "3"
            ) {
              splittedValue[formateSeriesm] =
                "0" + splittedValue[formateSeriesm];
              this.preapproval_application_form
                .get("second_page")
                .get("date_of_birth")
                .setValue(splittedValue.join(this.specialCharacter[0]));
            }
          }
          if (splittedValue[formateSeriesm] > "12") {
            splittedValue[formateSeriesm] = "0" + splittedValue[formateSeriesm];
            this.preapproval_application_form
              .get("second_page")
              .get("date_of_birth")
              .setValue(splittedValue.join(this.specialCharacter[0]));
          }
        }
      }
      if (splittedValue && splittedValue[formateSeriesd]) {
        if (
          splittedValue &&
          splittedValue[formateSeriesd].length == 1 &&
          splittedValue[formateSeriesd] > "3"
        ) {
          splittedValue[formateSeriesd] = "0" + splittedValue[formateSeriesd];
          this.preapproval_application_form
            .get("second_page")
            .get("date_of_birth")
            .setValue(splittedValue.join(this.specialCharacter[0]));
        } else if (
          splittedValue.length - 1 > formateSeriesd &&
          splittedValue[formateSeriesd].length == 1
        ) {
          splittedValue[formateSeriesd] = "0" + splittedValue[formateSeriesd];
          this.preapproval_application_form
            .get("second_page")
            .get("date_of_birth")
            .setValue(splittedValue.join(this.specialCharacter[0]));
        }
      }
    }
  }

  handleKeyDown(event: KeyboardEvent): void {
    // Check if the pressed key is not the left (37) or right (39) arrow key
    if (event.key === "ArrowLeft") {
      // Prevent the default behavior for other keys (disallow typing)
      event.preventDefault();
    }
  }

  handleMouseDown(event: MouseEvent): void {
    // Check if the pressed key is not the left (37) or right (39) arrow key
    if (
      event.type === "mousedown" &&
      this.preapproval_application_form &&
      this.preapproval_application_form.get("second_page").get("date_of_birth")
        .value.length >= 5
    ) {
      // Prevent the default behavior for other keys (disallow typing)
      event.preventDefault();
    } else if (event.type === "click") {
      const yourInputElement = document.getElementById("element");
      if (yourInputElement) {
        yourInputElement.focus();
      }
    }
  }

  alphabet(name) {
    let inputValue = name && name.target && name.target.value;
    if (this.mainService.document_label === "NINO/CRN") {
      if (inputValue && inputValue.length == 8) {
        var crnPattern = /^(?:[A-Z]{2}\d{6}|OC\d{4}[A-Z\d]{1,2}|SC\d{6}|NI\d{6})$/;
        if (!crnPattern.test(inputValue)) {
          this.dateError = true;
          return;

        }
      }
      if (inputValue && inputValue.length == 9) {
        // var crnPattern = /^[A-CEGHJ-PR-TW-Z]{2}\d{6}[ABCDHMNPRTWXYZ]$/;
        var crnPattern = /^[A-Z]{2}\d{6}[A-Z]$/
        console.log(crnPattern.test(inputValue));
        if (!crnPattern.test(inputValue)) {
          this.dateError = true;
          return;
        }
      }
      this.dateError = false;
    }
    if ((this.mainService.document_label != "NINO/CRN") && (this.mainService.document_label != "Fiscal Code/Codice Fiscale") && this.mainService.document_label != 'Tax Identification Number (NIF)') {
      const inputValue = (event.target as HTMLInputElement).value;
      const numericRegex = /^[0-9]*$/;

      if (inputValue && !numericRegex.test(inputValue)) {
        (event.target as HTMLInputElement).value = inputValue.replace(/[^0-9]/g, '');
        return
      }
    }
    const allowedChars = inputValue.replace(/[^a-zA-Z0-9]/g, ''); // Clean the input value by removing special characters
    if (inputValue !== allowedChars) {
      this.dateError = true;
      console.log("Invalid input: Special characters detected.");
      return
    }
    this.dateError = false;
  }

  regexCheck(name: any) {
    let inputValue = name && name.target && name.target.value;
    const allowedChars = inputValue.replace(/[^a-zA-Z0-9]/g, ''); // Clean the input value by removing special characters
    if (inputValue !== allowedChars) {
      this.dateErrors = true;
      console.log("Invalid input: Special characters detected.");
      return
    }
    let regexPattern = this.regexMode.regex;
    regexPattern = regexPattern && regexPattern.slice(1, -1);
    regexPattern = new RegExp(regexPattern)
    if (!regexPattern.test(inputValue)) {
      this.dateErrors = true
      return;
    }
    this.dateErrors = false
  }

  getZipCodeData(val,i) {
    return new Promise((resolve,reject) => {
      if (!val) {
        const getKey = i == 1 ? this.zip_obj?.['user_data']?.['user_data']?.addressObj : i == 2 ? this.zip_obj?.['employed_data']?.['employed_data']?.addressObj : this.zip_obj?.['office_data']?.['office_data']?.addressObj;  
        if((getKey && !getKey.zip) || (this.editAddressManually || this.editEmployerAddressManually || this.editOfficeAddressManually)) {
          getKey['custom_zip'] = 1;
        } else {
          getKey['custom_zip'] = 0;
        }
        if (!getKey.country_code) {
          getKey['country_code'] = this.mainService.defaultCountry['country_code'];
        }
        if (!getKey['latitude'] || !getKey['longitude']) {
          getKey['latitude'] = getKey['longitude'] = 0;
        }
        if (i == 1) {
          getKey.zip = this.preapproval_application_form.get('second_page').get('zip')?.value;
        } else if (i == 2) {
          getKey.zip = this.preapproval_application_form.get('third_employement_page').get('employeed').get('employer_zip').value;
        } else {
          getKey.zip = this.preapproval_application_form.get('third_employement_page').get('self_employeed').get('office_zip').value;
        }
        this.mainService.getZip(getKey).subscribe((res:any) => {
          const data = res?.data;
          if (data && (data.city_id && !res.is_error)) {
            if (i == 1) {
              this.preapproval_application_form.get('second_page').get('city_id')?.setValue(data.city_id);
            } else if (i == 2) {
              this.preapproval_application_form.get('third_employement_page').get('employeed').get('employer_city_id').setValue(data.city_id);
            } else {
              this.preapproval_application_form.get('third_employement_page').get('self_employeed').get('office_city_id').setValue(data.city_id);
            }
            this.mainService.setLoader(false);
            resolve(res);
          } else {
            const message = data?.message || data?.err || data?.override_text || 'Something went wrong';
            this.mainService.customPopups(message, 1);
            this.mainService.setLoader(false);
            reject(message);
          }
        });
      } else {
        console.log("error");
        reject("error");
      }
    })
  }

  getStates() {
    return new Promise((res, rej) => {
      const body = {
        country_id: this.mainService.defaultCountry['country_id']
      }
  
      this.mainService.newApi('post', environment.request_url + 'get_states', body).subscribe(country_states => {
        if (!country_states.is_error) {
          this.country_states = country_states.states;
          this.showDropDown = [1, 2].includes(+this.mainService.defaultCountry['country_id']);
          res(true);
        } else {
          this.mainService.customPopups(country_states.err || country_states.override_text, 1);
          rej();
        }
      });
    });

  }

  stateSelected(st_code: string, page: string, group?: string) {
    const form = this.preapproval_application_form.get(page);
    if (page == 'second_page') {
      const state_name = this.country_states.find(state => state.state_code == st_code)['state_name'];
      form.get('state').setValue(state_name);
      this.editAddressManually = true;
    } else if(page == 'third_employement_page') {
      if (group == 'employeed') {
        this.editEmployerAddressManually = true;
        form.get(group).get('employer_state').setValue(this.country_states.find(state => state.state_code == st_code)['state_name']);
      } else {
        this.editOfficeAddressManually = true;
        form.get(group).get('office_state').setValue(this.country_states.find(state => state.state_code == st_code)['state_name']);
      }
    }
  }
}